import React from 'react';
import injectSheet from 'react-jss';
import { graphql } from 'react-apollo';

import jsonSchema from 'shared/json_schemas/userRecoverForm';
import {compose} from 'shared/helpers';
import {
  gqlSubmitLoginForm,
} from 'shared/gql/auth';

import { mixClasses as cx } from 'helpers/styleHelper';
import manageUserAuthForm, { gqlSubmitFormCfg } from './manageUserAuthForm';  // XXX: Replace

import { FontIcon, DoubleBouncer, RectButton } from 'components/elems';
import Input from 'components/elems/Input';
import Formation from 'components/utils/Formation';


/*
 * UserRecoverForm
 */
const UserRecoverForm = (props) => {

  const btnIcon = (props.isSubmitting ?
    <DoubleBouncer /> :
    <FontIcon type="arrowright" style={{fontSize: '.875rem'}} />
  );

  return (
    <div>
      <div className="moa-ff-sans black-70">
        <div className="f3 mv2 fw6">
          Forgot your password?
        </div>
        <div className="mv4 lh-copy">
          Enter the email on your account, we will
          send you the instructions to reset your password.
        </div>
      </div>

      <div className={cx('mt4')}>
        <Formation
          formData={props.formData}
          onFocus={props.handleInputOnFocus}
          onChange={props.handleInputOnChange}
          onBlur={props.handleInputOnBlur}
        >
          <Input name="email" shouldFloatLabel={true} wrapClassName="mb2" />
        </Formation>

        <div className={cx('mt4 flex justify-end')}>
          <RectButton
            label="SUBMIT"
            icon={btnIcon}
            isEnabled={props.validateFormData()}
            isActivated={props.isSubmitting}
            onClick={props.submitForm}
          />
        </div>
      </div>
    </div>
  );
};

const styles = { };


export default compose(
  graphql(gqlSubmitLoginForm, gqlSubmitFormCfg),
  manageUserAuthForm(jsonSchema),
  injectSheet(styles),
)(UserRecoverForm);



// WEBPACK FOOTER //
// ./src/components/forms/UserRecoverForm.js